














































import { Component, Vue } from "vue-property-decorator";
import { State, Getter, Action } from "vuex-class";
import * as cg_user_types from "@/store/constants/cg_user_types";
import * as setting_types from "@/store/constants/setting_types";
import Container from "@/components/Container/Container.vue";
import NavTab from "@/components/NavTab/NavTab.vue";
import Swiper from "@/components/Swiper/Swiper.vue";
import { swiperSlide } from "vue-awesome-swiper";
import Scroller from "@/components/Scroller/Scroller.vue";
import CoinsTitle from "@/components/SkuTitle/CoinsTitle.vue";
import LimitedCoin from "@/components/CoinEntrance/limitCoins/limitCoins.vue";
import RegularCoin from "@/components/CoinEntrance/RegularCoin.vue";
import LuckyCoin from "@/components/CoinEntrance/LuckyCoin.vue";
import VipPackages from "@/components/CoinEntrance/VipPackages.vue";
import StoreTitle from "./StoreTitle/index.vue";
// import BackUpAppRecommend from "@/components/BackUpAppRecommend/BackUpAppRecommend.vue";
// import HotApp from "@/components/HotApps/HotApps.vue";
// import DailyChallenge from "@/components/DailyChallenge/DailyChallenge.vue";
import VipIntrodution from "./VipIntrodution/VipIntrodution.vue";
import { isVip } from "@/utils/general_utils";
import Event_bus from "@/utils/event_bus";
import { isIos } from "@/utils/lodash";
import * as cgConst from "@/api/cg/base/cg_const";

@Component({
  components: {
    Container,
    NavTab,
    Swiper,
    swiperSlide,
    Scroller,
    CoinsTitle,
    LimitedCoin,
    RegularCoin,
    VipPackages,
    StoreTitle,
    LuckyCoin,
    // BackUpAppRecommend,
    // HotApp,
    // DailyChallenge,
    VipIntrodution,
    VipFixedButton: () => import("./VipFixedButton/VipFixedButton.vue")
  }
})
export default class CoinsContainer extends Vue {
  @Getter(setting_types.GETTER_CLIENT_SETTINGS)
  private settingData: any;
  @Getter(cg_user_types.GETTER_COINS)
  private userCoins: any;
  @Action(setting_types.UPDATE_GX_SETTING_DATA)
  private updateCoinStoreSetting: any;
  private activeIndex = 0;
  private vipButtom = 80;

  private isVip: boolean = false;
  private tabsArr: object[] = [
    {
      label: "Buy Coins",
      labelColor: "#5C75EC",
      imgUrl: require("@/assets/icons-file/tab/coin_store_title_icon.png")
    }
    // {
    //   label: "Free Coins",
    //   labelColor: "#17C396",
    //   imgUrl: require("@/assets/icons-file/tab/free_coins_title_icon.png")
    // }
  ];
  private vipTab = {
    label: "Get VIP",
    labelColor: "#ff6f00",
    imgUrl: require("@/assets/icons-file/tab/store_vip_nav_icon.png")
  };

  get isIOS() {
    return isIos();
  }

  private created() {
    this.updateCoinStoreSetting(cgConst.TAB_COIN_STORE_KEYS).catch(
      (e: any) => void 0
    );
    // 一旦进入coins路由，则需要通知double coin bubble关闭
    Event_bus.$emit("show_double_coin_bubble", false);
    this.isIOS ? this.tabsArr.push(this.vipTab) : this.tabsArr;
  }

  private async activated() {
    this.isVip = isVip();
  }
  private getVipButtomHeight() {
    this.$nextTick(() => {
      try {
        if (!this.isVip) {
          this.vipButtom =
            window.innerHeight -
            (document.querySelector("#coin-store") as any).offsetHeight;
        }
      } catch (error) {
        //
      }
    });
  }

  private async mounted() {
    this.getVipButtomHeight();
  }
}
